import basicController from "servicestack/basic.controller.properties";
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from 'ioc/resolve';
import formioController from "webforms/formio/formio.controller";

export default class RetailerFormSubmissionPromptController {
	constructor($scope) {
		const $ctrl = this;
		formioController($ctrl, $scope);
		$ctrl.bus = new ServiceBus();
		let $rootScope = resolve('$rootScope');
	}
	formSubmission(e, submission) {
		const $ctrl = this;
		$ctrl.$close(submission);
	}
	submit() {
		const $ctrl = this;
		//$ctrl.bus.send('RequestFormSubmission.json', $ctrl.request).then(res => $ctrl.$close(res));
	}
}
